/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: env,appParameters,環境変数
 * note:
 *  - appParameters.*.jsonの情報を、Webappで利用できる様にする
 * sample:
 *  -
 * :ZNOTE:
 */

let params: any = process.env.APP_PARAMS;

if (typeof process.env.APP_PARAMS === 'string') {
  try {
    params = JSON.parse(params);
  } catch{}
}

const getAppParams = (): any => params;

export {getAppParams};
